import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { ArrowRight } from "lucide-react";
const bundleMeta = [{
  eyebrow: "EDITION 01 · THE TASTER",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709989/img/taster_collection.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709989/img/taster_collection.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709989/img/taster_collection.png-wvc-sizes",
  alt: "Artisanal ice cream taster collection with four signature flavors on cream background",
  specs: [{
    label: "FLAVORS",
    value: "04"
  }, {
    label: "VOLUME",
    value: "473ml"
  }, {
    label: "DAIRY",
    value: "Organic"
  }, {
    label: "TEXTURE",
    value: "Velvet"
  }, {
    label: "ORIGIN",
    value: "Local"
  }]
}, {
  eyebrow: "EDITION 02 · THE CONNOISSEUR",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709989/img/connoisseur_selection.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709989/img/connoisseur_selection.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709989/img/connoisseur_selection.webp-wvc-sizes",
  alt: "Connoisseur selection with six premium ice cream pints and artisanal toppings",
  specs: [{
    label: "FLAVORS",
    value: "06"
  }, {
    label: "VOLUME",
    value: "473ml"
  }, {
    label: "DAIRY",
    value: "Organic"
  }, {
    label: "TEXTURE",
    value: "Velvet"
  }, {
    label: "ORIGIN",
    value: "Local"
  }]
}, {
  eyebrow: "EDITION 03 · THE CELEBRATION",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709989/img/celebration_box.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709989/img/celebration_box.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1709989/img/celebration_box.png-wvc-sizes",
  alt: "Celebration box with twelve assorted ice cream pints and signature waffle cones",
  specs: [{
    label: "FLAVORS",
    value: "12"
  }, {
    label: "VOLUME",
    value: "473ml"
  }, {
    label: "DAIRY",
    value: "Organic"
  }, {
    label: "TEXTURE",
    value: "Velvet"
  }, {
    label: "ORIGIN",
    value: "Local"
  }]
}];
function BundleRows() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div className="space-y-16 md:space-y-20">
        {[0, 1, 2].map(i => <div key={i} data-index={i} className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10">
            <div className="md:col-span-8 aspect-[4/3] bg-muted border border-border animate-pulse" />
            <div className="md:col-span-4 h-64 bg-muted border border-border animate-pulse" />
          </div>)}
      </div>;
  }
  if (error) {
    return <p className="font-mono text-xs uppercase tracking-wider text-muted-foreground">
        {"Unable to load collections."}
      </p>;
  }
  if (!products || products.length === 0) {
    return <p className="font-mono text-xs uppercase tracking-wider text-muted-foreground">
        {"No collections available."}
      </p>;
  }
  const items = products.slice(0, 3);
  return <div className="space-y-16 md:space-y-24">
      {items.map((product, i) => {
      const meta = bundleMeta[i] ?? bundleMeta[0];
      const reverse = i % 2 === 1;
      return <article data-index={i} key={product.id} className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-stretch group">
            <div className={`md:col-span-8 ${reverse ? "md:order-2" : "md:order-1"}`}>
              <Link to={product.link} className="block">
                <div className="relative aspect-[4/3] overflow-hidden border border-border bg-background transition-colors duration-200 group-hover:border-primary">
                  <img src={product.featured_image_url || meta.image} alt={product.title || meta.alt} loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.02]" />
                </div>
              </Link>
            </div>

            <div className={`md:col-span-4 flex flex-col ${reverse ? "md:order-1" : "md:order-2"}`}>
              <div className="font-mono text-[0.6875rem] tracking-[0.08em] uppercase text-muted-foreground mb-4">
                {meta.eyebrow}
              </div>

              <Link to={product.link}>
                <h3 className="font-default text-xl md:text-2xl font-medium leading-tight tracking-tight text-foreground mb-6 hover:text-primary transition-colors duration-150">
                  {product.title}
                </h3>
              </Link>

              <div className="border-t border-border mb-6">
                {meta.specs.map((spec, idx) => <div data-index={idx} key={spec.label} className="flex items-center justify-between border-b border-border py-3 px-1 -mx-1 transition-colors duration-150 hover:bg-accent">
                    <span className="font-mono text-[0.6875rem] tracking-[0.08em] uppercase text-muted-foreground">
                      {spec.label}
                    </span>
                    <span className="font-mono text-[0.8125rem] text-foreground tabular-nums">
                      {spec.value}
                    </span>
                  </div>)}
              </div>

              <div className="flex items-baseline gap-2 mb-6">
                <span className="font-mono text-[0.6875rem] tracking-[0.08em] uppercase text-muted-foreground">
                  {"PRICE"}
                </span>
                <span className="font-mono text-2xl font-medium text-foreground tabular-nums">
                  {"$"}
                  {typeof product.price === "number" ? product.price.toFixed(2) : product.price}
                </span>
              </div>

              <div className="mt-auto">
                <AddToCartButton productId={product.id} variant="outline" className="w-full" buttonClassName="bg-primary text-primary-foreground hover:bg-foreground" text="Select & order" showQuantity={false} />
              </div>
            </div>
          </article>;
    })}
    </div>;
}
export default function Bundles() {
  const wp_query_params = {
    per_page: 3,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="11116" id="curated-bundles" className="bg-background text-foreground border-t border-border py-24 md:py-32">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10 lg:px-14">
        {}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10 mb-20 md:mb-28">
          <div className="md:col-span-7">
            <div className="font-mono text-[0.6875rem] tracking-[0.08em] uppercase text-muted-foreground mb-6">
              {"ARTISANAL · HAND-CRAFTED · DELIVERED FRESH"}
            </div>
            <h2 className="font-default font-semibold text-foreground leading-[0.98] tracking-[-0.025em] text-[clamp(2.75rem,5.4vw,4.75rem)]">
              {"Curated collections for the true ice cream lover."}
            </h2>
          </div>

          <div className="md:col-span-5 flex flex-col justify-between gap-8">
            <p className="font-default text-[clamp(1rem,1.05vw,1.125rem)] leading-[1.55] text-muted-foreground">
              {"Experience our signature flavors in perfectly curated sets. From small-batch taster collections to grand celebration boxes, every order is packed with care to ensure the perfect scoop arrives at your doorstep."}
            </p>
            <div>
              <Link to="/ShopPage">
                <Button size="lg" className="h-12 px-6 bg-primary text-primary-foreground hover:bg-foreground font-medium">
                  {"View all collections"}
                  <ArrowRight className="ml-1 h-4 w-4" />
                </Button>
              </Link>
            </div>
          </div>
        </div>

        {}
        <EcommerceProductsProvider wp_query={{
        per_page: 3,
        orderby: "date",
        order: "desc"
      }}>
          <BundleRows />
        </EcommerceProductsProvider>
      </div>
    </section>;
}